// env: 'local' or 'session'

export default {
  methods: {
    getFiltersFromStorage({
      env = 'session',
      target = 'filters',
      raw = false,
    } = {}) {
      const storageTypes = {
        local: localStorage,
        session: sessionStorage,
      };

      let filters = storageTypes[env].getItem(target);

      if (filters) {
        filters = JSON.parse(filters);

        if (raw) return filters;

        const { responsible, promoter, ...rest } = filters;
        return {
          ...rest,
          ...(promoter ? { promoter_id: promoter.value } : ''),
          ...(responsible ? { responsible_id: responsible.value } : ''),
        };
      }

      return {};
    },
  },
};
